/** Copyright (c) 2022 T. Rowe Price. All rights reserved. */

import './IntradayRefreshIcon.scss';

import React from 'react';
import { connect } from 'react-redux';

import { ReactComponent as Refresh } from 'assets/icons/refresh.svg';
import IntradayRefreshSpinner from 'components/shared/Intraday/IntradayRefreshSpinner';
import { getIntradayPricing } from 'services/Rest';
import { getIntradayRefreshStatus } from 'state/account/AccountSelectors';

const IntradayRefreshIcon = ({ status }) => {
  const onRequestUpdate = (e) => {
    e.preventDefault();
    getIntradayPricing();
  };

  const { isPending } = status;

  return (
    <button
      data-testid="intraday-refresh-icon"
      className="intraday-refresh-icon"
      onClick={onRequestUpdate}>
      {!isPending && <Refresh />}
      {isPending && <IntradayRefreshSpinner />}
    </button>
  );
};

const mapStateToProps = (state) => ({
  status: getIntradayRefreshStatus(state)
});

export default connect(mapStateToProps)(IntradayRefreshIcon);
